import { Link } from 'react-router';
import { NAV_PATH } from '@/router/constants';

const FirstContent = () => {
	return (
		<section className="sub-content cont1">
			<div className="sub-inner">
				<p className="price-desc">2025년 12월까지 한시적 적용</p>
				<ul className="price-card">
					<li className="price-item event">
						<span className="event-label">
							<p>
								무료체험 <em>EVENT</em>
							</p>
						</span>
						<strong className="title">연간 이용권</strong>
						<span>
							<div className="sale">
								<p>
									<strong>1,200,000</strong>
									<p className="label">
										1년 선납 2개월 할인+<span>오픈 프로모션</span>
									</p>
								</p>
							</div>
							<div className="price">
								<p>
									<strong>700,000</strong> 원
								</p>
								<span>(VAT 별도)</span>
							</div>
							<span className="sub">
								신규가입 시 <em>2개월 무료체험</em> 기간 제공!
							</span>
						</span>
					</li>
					<li className="price-item">
						<span className="event-label">
							<p>
								무료체험 <em>EVENT</em>
							</p>
						</span>
						<strong className="title">월간 이용권</strong>
						<span>
							<div className="sale">
								<p>
									<strong>100,000</strong>
									<p className="label">
										<span>오픈 프로모션</span>
									</p>
								</p>
							</div>
							<div className="price">
								<p>
									<strong>70,000</strong> 원
								</p>
								<span>(VAT 별도)</span>
							</div>
							<span className="sub">
								신규가입 시 <em>2개월 무료체험</em> 기간 제공!
							</span>
						</span>
					</li>
				</ul>
				<ul className="price-infomation">
					<li>
						<i className="ico1"></i>
						<p>
							<span className="font-bold">사용자</span> 무제한
						</p>
					</li>
					<li>
						<i className="ico2"></i>
						<p>
							<span className="font-bold">무제한</span> 전자세금계산서 발행
						</p>
					</li>
					<li>
						<i className="ico3"></i>
						<p>
							<span className="font-bold">20,000 포인트</span> 제공
							<span className="sub">*사업자번호당 최초 1회 제공</span>
						</p>
					</li>
					<li>
						<i className="ico4"></i>
						<p>
							ERP사 유일 <span className="font-bold">거래처 신용정보</span> 제공
						</p>
					</li>
				</ul>
			</div>
		</section>
	);
};

export default FirstContent;
